import metrics from './fontMetrics.js';
export const REPORT_FONT_FAMILY = 'Report Liberation Sans';
const faces = {
    normal: 'Regular',
    bold: 'Bold',
    italic: 'Italic',
    bolditalic: 'BoldItalic',
};
/** Advance widths are generated from the bundled TTF hmtx/cmap tables. Disable
 * kerning/ligatures in the preview so preview, PDF and PowerPoint agree. */
export function measureReportText(text, size, style = 'normal') {
    const face = metrics[style];
    const widths = face.widths;
    return ((Array.from(text).reduce((total, char) => total + (widths[String(char.codePointAt(0))] ?? widths['63'] ?? face.unitsPerEm / 2), 0) *
        size) /
        face.unitsPerEm);
}
export function reportFontAscent(size, style = 'normal') {
    return (size * metrics[style].ascent) / metrics[style].unitsPerEm;
}
